import moment from 'moment';
import * as Yup from 'yup'

// patientsNationalityOptions 
export const PatientsNationalityOptions = [
    { value: 'Indian', label: 'Indian' },
    { value: 'International', label: 'International' }
];

//Primary Refractory Options
export const PrimaryRefractoryOptions = [
    { value: '1', label: 'Yes' },
    { value: '0', label: 'No' }
]

//Bulky Disease Options
export const BulkyDiseaseOptions = [
    { value: '1', label: 'Yes ( >7 cm )' },
    { value: '0', label: 'No ( <7 cm )' }
]

//Bulky Disease Options
export const primaryDiagnosisOptions = [
    { value: '1', label: 'B cell ALL' },
    { value: '2', label: 'B cell NHL' },
    { value: '3', label: 'Any other'},
]
//Bulky Disease Options
export const primaryDiagnosisSubtypeOptions = [
    { value: '1', label: 'GCB' },
    { value: '2', label: 'ABC' },
]


export const SUPPORTED_FORMATS = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
];

export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const fileArraySchema = Yup.array()
    .of(
        Yup.mixed()
            .test("fileType", "Unsupported file format", file =>
                file ? SUPPORTED_FORMATS.includes(file?.file_type) : true
            )
            .test("fileSize", "File too large (max 25MB)", file =>
                file ? file?.file_size < MAX_FILE_SIZE : true
            )
    )
    .nullable();
    
const requiredIfNotDraft = (schema, message, isDraft) => {
  return isDraft ? schema.notRequired() : schema.required(message);
};

export const PreScreenValidationSchema = (isDraft = false) =>
  Yup.object().shape({

    hospital_name: Yup.string().max(255, "Enter less than 255 characters"),
   
    patient_name: Yup.string().max(50, "Enter less than 50 characters"),

    patient_age: requiredIfNotDraft(
      Yup.string(),
      "Patient age is required",
      isDraft
    ),
    hospital_patient_id: requiredIfNotDraft(
  Yup.string()
    .nullable()
    .matches(
      /^[A-Za-z0-9]+$/, // Only alphanumeric characters allowed
      'Hospital Patient ID can only contain letters and numbers'
    )
    .test(
      'contains-both',
      'Hospital Patient ID must contain at least one letter and one number',
      (value) => {
        if (isDraft && (!value || value.trim() === '')) {
          return true; // Allow empty in draft mode
        }
        
        // Non-draft: must exist
        if (!isDraft && (!value || value.trim() === '')) {
          return false;
        }
        
        const strValue = String(value);
        // Check if contains at least one letter AND at least one number
        const hasLetter = /[A-Za-z]/.test(strValue);
        const hasNumber = /[0-9]/.test(strValue);
        
        return hasLetter && hasNumber;
      }
    ),
  "Hospital Patient ID is required",
  isDraft
),

    patient_body_weight: requiredIfNotDraft(
      Yup.number()
        .typeError("Patient weight must be a number")
        .max(200, "Enter less than 200 number")
        .positive("Patient weight must be positive"),
      "Patient weight is required",
      isDraft
    ),
    primary_refractory: requiredIfNotDraft(Yup.string()
        .nullable(),
        "Please select a primary refractory",
         isDraft
    ),
    gender: requiredIfNotDraft(
      Yup.string(),
      "Please select an option",
      isDraft
    ),
   
    patients_nationality: requiredIfNotDraft(
      Yup.string().nullable(),
      "Please select a patient's nationality",
      isDraft
    ),

    state_id: Yup.string()
      .nullable()
      .when(['patients_nationality'], {
        is: (val) => val === 'Indian' && !isDraft,
        then: schema => schema.required('Please select a state'),
        otherwise: schema => schema.notRequired()
      }),

    city_id: Yup.string()
      .nullable()
      .when(['patients_nationality'], {
        is: (val) => val === 'Indian' && !isDraft,
        then: schema => schema.required('Please select a city'),
        otherwise: schema => schema.notRequired()
      }),

    mention_nationality: Yup.string().when('patients_nationality', {
      is: (val) => val === 'International' && !isDraft,
      then: schema => schema.required('Please enter nationality'),
      otherwise: schema => schema.notRequired()
    }),

    primary_diagnosis_id: requiredIfNotDraft(
      Yup.number().integer("Must be a number").nullable(),
      "Please select a primary diagnosis",
      isDraft
    ),
       // NEW: Last Regimen Start/Stop Dates validation
    last_treatment_dates: isDraft
      ? Yup.object().shape({
          start_date: Yup.string()
            .nullable()
            .typeError('start date is required'),
          stop_date: Yup.string()
            .nullable()
            .typeError('Stop date is required'),
        }).notRequired()
      : Yup.object().shape({
          start_date: Yup.string()
            .required('Start date is required'),
          stop_date: Yup.string()
            .required('Stop date is required')
        }).required('Last treatment dates are required'),
      "biopsy-report": Yup.array()
      .nullable()
      .when("primary_diagnosis_id", {
        is: (val) => val === 1 && !isDraft,
        then: (schema) =>
          schema
            .min(1, "Please upload at least one bone marrow aspiration & biopsy Report")
            .required("Please upload bone marrow aspiration & biopsy Report"),
        otherwise: (schema) => schema.notRequired(),
      }),
      "histopathology-report": Yup.array()
      .nullable()
      .when("primary_diagnosis_id", {
        is: (val) => val === 2 && !isDraft,
        then: (schema) =>
          schema
            .min(1, "Please upload at least one histopathology report with IHC report")
            .required("Please upload  histopathology report with IHC report"),
        otherwise: (schema) => schema.notRequired(),
      }),
      
    "flow-cytometry": Yup.array()
      .nullable()
      .when("primary_diagnosis_id", {
        is: (val) => val === 1 && !isDraft,
        then: (schema) =>
          schema
            .min(1, "Please upload at least one flow cytometry report")
            .required("Please upload flow cytometry report"),
        otherwise: (schema) => schema.notRequired(),
      }),
      "pet-ct-report": Yup.array()
      .nullable()
      .when("primary_diagnosis_id", {
        is: (val) => val === 2 && !isDraft,
        then: (schema) =>
          schema
            .min(1, "Please upload at least one pet CT report")
            .required("Please upload pet CT report"),
        otherwise: (schema) => schema.notRequired(),
      }),
      
/*
    "ihc-report": Yup.array().when('primary_diagnosis_id', {
      is: (val) => [1, 2].includes(val) && !isDraft,
      then: schema =>
        schema.required('Please upload IHC report')
              .min(1),
      otherwise: schema => schema.notRequired()
    }),*/
    
  baseline_crp_level: requiredIfNotDraft(
      Yup.string().nullable(),
      "Please enter a baseline CRP",
      isDraft
    ),
    biopsy_confirmed: requiredIfNotDraft(
      Yup.string().nullable(),
      "Please select a biopsy confirmed",
      isDraft
    ),
      bulky_disease_dlbcl: Yup.number()
      .nullable().notRequired(),
     last_treatment_regimen: requiredIfNotDraft(
      Yup.string().nullable(),
      "Please enter last treatment regimen",
      isDraft
    ),
    cytogenetic_report: requiredIfNotDraft(
      Yup.string().nullable(),
      "Please select a cytogenetic report",
      isDraft
    ),

    date_of_last_relapse_or_refractoriness: requiredIfNotDraft(
      Yup.string(),
      "Date of last relapse or refractoriness is required",
      isDraft
    ),

    number_of_lines_of_therapies_prior_to_car_t: requiredIfNotDraft(
      Yup.number()
        .typeError("Must be a number")
        .max(100, "Enter less than or equal to 100")
        .positive("Must be a positive number")
        .nullable(),
      "Number of prior lines of therapy is required",
      isDraft
    ),

    treatment_history: isDraft
      ? Yup.array().notRequired()
      : Yup.array()
          .min(1, "Treatment history is required")
          .of(
            Yup.object().shape({
              treatment_for: Yup.string().required("Drug(s) is required"),
              start_date: Yup.string().required("Start date is required"),
              end_date: Yup.string().required("End date is required"),
            })
          ),

    b_all_blast_percentage: Yup.string()
      .nullable().notRequired(),
    ecog_ps: requiredIfNotDraft(
      Yup.number()
        .typeError("ECOG performance score must be a number")
        .min(0, "ECOG score cannot be negative")
        .max(1000, "Enter less than or equal to 1000")
        .nullable(),
      "ECOG performance score is required",
      isDraft
    ),
      "discharge-summary": isDraft
      ? Yup.array().notRequired()
      : Yup.array()
          .min(1, "Treatment history is required")
          .required("Please upload treatment Summary"),
    lvef_percentage: requiredIfNotDraft(
      Yup.number()
        .typeError("LVEF % must be a number")
        .min(0, "LVEF % cannot be negative")
        .max(1000, "Enter less than or equal to 1000")
        .nullable(),
      "LVEF % is required",
      isDraft
    ),
     baseline_ldh_level: requiredIfNotDraft(
      Yup.number()
        .typeError("Baseline LDH must be a number")
        .nullable(),
      "Baseline LDH is required",
      isDraft
    ),
     "apheresisDateRange": Yup.object()
        .shape({
            startDate: isDraft ? Yup.date()
                .notRequired() : Yup.date()
                .required('Date is required')
                .typeError('Please select a valid start date'),
            endDate: isDraft ? Yup.date()
                .notRequired() : Yup.date()
                .required('Date is required')
                .typeError('Please select a valid end date')
                .min(
                    Yup.ref('startDate'),
                    'End date must be after start date'
                ),
        })
        .required('Date range is required')
        .test(
            'is-valid-range',
            'Please select a valid date range',
            function(value) {
                 if(isDraft)
                  return true 
                if (!value || !value.startDate || !value.endDate) {
                    return false;
                }
                return value.startDate <= value.endDate;
            }
        ),
        preferred_date: Yup.array()
        .of(Yup.string())
         .notRequired()
        .test(
            'len-check',
            'You can select between 1 and 5 preferred dates',
            value => !value || value?.length == 0 || (value.length >= 1 && value.length <= 5)
        )

  });



export const clinicalStatus = [
    { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
    { lable: "Clinical Feasible", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Feasible with Conditions", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Feasible", color: "error", bgColor: "#FFE3E3", text: "#FF2023" }
]
export const financialStatus = [
    { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
    { lable: "Financial Feasible", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Feasible", color: "error", bgColor: "#FFE3E3", text: "#FF2023" },
    { lable: "Special Approval", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Applicable", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" }
]


export function transformDataWithFiles(data) {
    const transformedFiles = {};

    if (Array.isArray(data.files)) {
        data.files.forEach(file => {
            if (file?.file_key && file?.media) {
                transformedFiles[file?.file_key] = file?.media;
            }
        });
    }

    const { ...rest } = data;

    return {
        ...rest,
        ...transformedFiles
    };
}


export const returnPostData = (values) => {
    const result = Object.fromEntries(
        Object.entries(values).map(([key, value]) => {
            if (Array.isArray(value) && key != "treatment_history" && key != "preferred_date") {
                const ids = value
                    .filter(obj => obj && typeof obj === 'object' && 'id' in obj)
                    .map(obj => obj.id);
                return [key, ids];
            }
            return [key, value];
        })
    );
    return result
}

export function getNestedValue(obj, path) {
    if (!path) return undefined;
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

export const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Returns format: YYYY-MM-DD
};

export function isValidDynamicDate(dateStr) {
    // Common date formats to check (strictly)
    const commonFormats = [
        'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD',
        'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD',
        'DD.MM.YYYY', 'MM.DD.YYYY', 'YYYY.MM.DD',
        'D-M-YYYY', 'M-D-YYYY', 'YYYY-M-D', // Handles single-digit days/months
        'DD MMM YYYY', 'MMM DD YYYY' // Like '29 Jun 2025'
    ];

    // Try each format with strict parsing
    for (const format of commonFormats) {
        if (moment(dateStr, format, true).isValid()) {
            return true;
        }
    }

    // Fallback: Let Moment.js guess (less reliable)
    return moment(dateStr).isValid();
}

export const formatDayNumber = (num) => {
  const strNum = num?.toString();
  return strNum?.startsWith('0') ? strNum : (num < 10 ? `0${num}` : strNum);
};

export const areAllObjectsFilled = (arr) =>  {
  return arr.every(obj =>
    Object.values(obj).every(val => val !== null && val !== undefined && val !== "")
  );
}